import { FaFilePdf } from "react-icons/fa6";
import { TbFileTypeDocx } from "react-icons/tb";
import { TbFileTypeDoc } from "react-icons/tb";


export const DEFAULT_THEME_COLOR = '#C05222';

//export const API_END_POINT = "http://ec2-52-66-236-194.ap-south-1.compute.amazonaws.com/api/";
export const API_END_POINT =  process.env.REACT_APP_API_BASE;
//export const API_END_POINT = "https://projectcontrolhub.staging.pwc.in/api/api/";
export const DEFAULT_PROJECT_DASHBOARD = "project-landing";
export const DASHBOARD_PATH = "/program-dashboard/program-dashboard"
export const LOGIN_PATH = "/login"
export const MAP_API_KEY = "AIzaSyCV9PyvQW3qL7PrxbWiQFefFtEROrBemXo"

// do not change roles position and name
export const MAIN_ROLES = [
    "System Admin",
    "Admin"
]; 

export const FILE_ICONS = [
    {
        type: 'pdf',
        icon: <FaFilePdf style={{
            height: '20px', width: '20px'
        }} />
    },
    {
        type: 'docx',
        icon: <TbFileTypeDocx style={{
            height: '20px', width: '20px'
        }} />
    },
    {
        type: 'doc',
        icon: <TbFileTypeDoc style={{
            height: '20px', width: '20px'
        }} />
    },
]



// ALl Permissions

// for Project Dashboard
export const PROJECT_HOME_ACCESS = 'project_home_access';
export const SMT_SCHEDULE_ACCESS = 'smt_schedule_access';
export const SMT_CONSTRUCTION_ACCESS = 'smt_construction_access';
export const SMT_MILESTONE_ACCESS = 'smt_milestone_access';
export const SMT_ENGINEERING_ACCESS = 'smt_engineering_access';
export const SMT_PM_ACCESS = 'smt_pm_access';
export const SMT_MANPOWERPRODUCT_ACCESS = 'smt_manpowerproduct_access';

export const FINANCIAL_PROGRESS_DASH_ACCESS = 'financial_progress_dash_access';
export const PAYMENT_TRACKER_DASH_ACCESS = 'payment_tracker_dash_access';

export const VENDOR_DASH_ACCESS = 'vendor_dash_access';
export const PROCUREMENT_DASH_ACCESS = 'procurement_dash_access';

export const CLAIM_AND_CHANGE_ORDER_DASH_ACCESS = 'claim_and_change_order_dash_access';

export const ISSUES_DASH_ACCESS = 'issues_dash_access';
export const KEY_CLEATANCE_DASH_ACCESS = 'key_clearance_dash_access';
export const RISK_DASH_ACCESS = 'risk_dash_access';
export const SAFETY_DASH_ACCESS = 'safety_dash_access';
export const QUALITY_DASH_ACCESS = 'quality_dash_access';

// for users
export const USERS_ADD = 'users_add';
export const USERS_BULK_UPLOAD = 'users_bulk_upload';
export const USERS_EDIT = 'users_edit';
export const USERS_DISABLE = 'users_disable';
export const USERS_ACCESS = 'users_access';

// for Bulk User Transaction
export const BULK_USER_TRANSACTION_VIEW = 'bulk_user_transaction_view';
export const BULK_USER_TRANSACTION_ACCESS = 'bulk_user_transaction_access';

// for Roles
export const ROLE_ADD = 'role_add';
export const ROLE_EDIT = 'role_edit';
export const ROLE_DELETE = 'role_delete';
export const ROLE_ACCESS = 'role_access';

// for Files
export const FILE_ADD = 'file_add';
export const FILE_VIEW = 'file_view';
export const FILE_APPROVAL = 'file_approval';
export const FILE_ACCESS = 'file_access'


// for schedule
export const SCHEDULE_ACCESS = 'schedule_access';

// for construction
export const CONSTRUCTION_ACCESS = 'construction_access';

// for milestone
export const MILESTONE_ACCESS = 'milestone_access';
export const MILESTONE_VIEW = 'milestone_view';
export const MILESTONE_APPROVAL = 'milestone_approval';

// for assign permission
export const PERMISSION_ADD = 'permission_add';
export const PERMISSION_ACCESS = 'permission_access';

// for eNGINEERING DCOCUMENT
export const ENGINEERING_ACCESS = 'engineering_access';
export const ENGINEERING_MANAGE_DRAWING = 'engineering_manage_drawing';
export const ENGINEERING_DCOCUMENT_CREATE = 'engineering_document_create';
export const ENGINEERING_DCOCUMENT_VIEW = 'engineering_document_view';
export const ENGINEERING_DCOCUMENT_EDIT = 'engineering_document_edit';
export const ENGINEERING_DCOCUMENT_DELETE = 'engineering_document_delete';
export const ENGINEERING_DCOCUMENT_APPROVAL = 'engineering_document_approval';

// for key issue
export const KEY_ISSUE_CREATE = 'key_issue_create';
export const KEY_ISSUE_VIEW = 'key_issue_view';
export const KEY_ISSUE_EDIT = 'key_issue_edit';
export const KEY_ISSUE_DELETE = 'key_issue_delete';
export const KEY_ISSUE_APPROVAL = 'key_issue_approval';
export const KEY_ISSUE_ACCESS = 'key_issue_access';

// for risk
export const RISK_CREATE = 'risk_create';
export const RISK_VIEW = 'risk_view';
export const RISK_EDIT = 'risk_edit';
export const RISK_DELETE = 'risk_delete';
export const RISK_APPROVAL = 'risk_approval';
export const RISK_ACCESS = 'risk_access';

// for key Clearance
export const KEY_CLEARANCE_CREATE = 'key_clearance_create';
export const KEY_CLEARANCE_VIEW = 'key_clearance_view';
export const KEY_CLEARANCE_EDIT = 'key_clearance_edit';
export const KEY_CLEARANCE_DELETE = 'key_clearance_delete';
export const KEY_CLEARANCE_APPROVAL = 'key_clearance_approval';
export const KEY_CLEARANCE_ACCESS = 'key_clearance_access';

// for Safety
export const SAFETY_CREATE = 'safety_create';
export const SAFETY_VIEW = 'safety_view';
export const SAFETY_EDIT = 'safety_edit';
export const SAFETY_DELETE = 'safety_delete';
export const SAFETY_APPROVAL = 'safety_approval';
export const SAFETY_ACCESS = 'safety_access';

// for quality
export const QUALITY_CREATE = 'quality_create';
export const QUALITY_VIEW = 'quality_view';
export const QUALITY_EDIT = 'quality_edit';
export const QUALITY_DELETE = 'quality_delete';
export const QUALITY_APPROVAL = 'quality_approval';
export const QUALITY_ACCESS = 'quality_access';

// for change order
export const CHANGE_ORDER_CREATE = 'change_order_create';
export const CHANGE_ORDER_VIEW = 'change_order_view';
export const CHANGE_ORDER_EDIT = 'change_order_edit';
export const CHANGE_ORDER_DELETE = 'change_order_delete';
export const CHANGE_ORDER_APPROVAL = 'change_order_approval';
export const CHANGE_ORDER_ACCESS = 'change_order_access';

// for claim
export const CLAIM_CREATE = 'claim_create';
export const CLAIM_VIEW = 'claim_view';
export const CLAIM_EDIT = 'claim_edit';
export const CLAIM_DELETE = 'claim_delete';
export const CLAIM_APPROVAL = 'claim_approval';
export const CLAIM_ACCESS = 'claim_access';

// for manpower
export const MANPOWER_ACCESS = 'manpower_access';

// for p&m
export const PM_CREATE = 'pm_create';
export const PM_VIEW = 'pm_view';
export const PM_EDIT = 'pm_edit';
export const PM_DELETE = 'pm_delete';
export const PM_APPROVAL = 'pm_approval';
export const PM_ACCESS = 'pm_access';

// for monte carlo simulation
export const MONTE_CARLO_SIMULATION_ACCESS = 'monte_carlo_simulation_access';
export const MONTE_CARLO_SIMULATION_CREATE = 'monte_carlo_simulation_create';
export const MONTE_CARLO_SIMULATION_VIEW = 'monte_carlo_simulation_view';
export const MONTE_CARLO_SIMULATION_RESULT = 'monte_carlo_simulation_result';
export const MONTE_CARLO_SIMULATION_PUBLISH = 'monte_carlo_simulation_publish';

// for financial-progress
export const FINANCIAL_PROGRESS_ACCESS = 'financial_progress_access';

// for payment tracker
export const PAYMENT_TRACKER_ACCESS = 'payment_tracker_access';

// for boq
export const BOQ_ACCESS = 'boq_access';

// for bim viewer
export const BIM_VIEWER_ACCESS = 'bim_viewer_access';

// for Procurement
export const PROCUREMENT_ACCESS = 'procurement_access';

// for vendor_performance_tracker
export const VENDOR_PERFORMANCE_TRACKER_ACCESS = 'vendor_performance_tracker_access';

// for image gallery
export const IMAGE_GALLERY_CREATE = 'image_gallery_create';
export const IMAGE_GALLERY_VIEW = 'image_gallery_view';
export const IMAGE_GALLERY_EDIT = 'image_gallery_edit';
export const IMAGE_GALLERY_DELETE = 'image_gallery_delete';
export const IMAGE_GALLERY_APPROVAL = 'image_gallery_approval';
export const IMAGE_GALLERY_ACCESS = 'image_gallery_access';

// for dpr quantity
export const DPR_QUANTITY_EDIT = 'dpr_quantity_edit';
export const DPR_QUANTITY_ACCESS = 'dpr_quantity_access';

// for dpr p&m
export const DPR_PM_EDIT = 'dpr_pm_edit';
export const DPR_PM_ACCESS = 'dpr_pm_access';

// for project settings
export const PROJECT_SETTING_CREATE = 'project_setting_create';
export const PROJECT_SETTING_VIEW = 'project_setting_view';
export const PROJECT_SETTING_EDIT = 'project_setting_edit';
export const PROJECT_SETTING_DELETE = 'project_setting_delete';
export const PROJECT_SETTING_ACCESS = 'project_setting_access';

// for norms
export const NORMS_EDIT = 'norms_edit';
export const NORMS_ACCESS = 'norms_access';

// for workflow managment
export const WORKFLOW_CREATE = 'workflow_create';
export const WORKFLOW_VIEW = 'workflow_view';
export const WORKFLOW_EDIT = 'workflow_edit';
export const WORKFLOW_DELETE = 'workflow_delete';
export const WORKFLOW_ACCESS = 'workflow_access';

// for Data Metrics Management
export const DATA_METRICS_CREATE = 'data_metrics_create';
export const DATA_METRICS_VIEW = 'data_metrics_view';
export const DATA_METRICS_EDIT = 'data_metrics_edit';
export const DATA_METRICS_DELETE = 'data_metrics_delete';
export const DATA_METRICS_ACCESS = 'data_metrics_access';

// for help
export const HELP_FEATURE_LIST_ACCESS = 'help_feature_list_access';
export const HELP_DATA_SETS_LIST_ACCESS = 'help_data_sets_list_access';

export const PROGRAM_DASHBOARD_MENU = 'program_dashboard_menu';
export const PORTFOLIO_DASHBOARD_MENU = 'portfolio_dashboard_menu';
export const PROJECT_MENU = 'project_menu';
export const USER_MANAGEMENT_MENU = 'user_management_menu';

